module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.elementId
    },
    on: {
      "mousemove": function($event) {
        return _vm.setSprite($event)
      },
      "mouseout": function($event) {
        return _vm.clearSprite()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.spriteOffset === null),
      expression: "spriteOffset === null"
    }],
    staticClass: "thumbnail-default",
    style: (_vm.defaultStyling)
  }), _vm._v(" "), _c('div', {
    staticClass: "thumbnail-previews",
    class: {
      'invisible': _vm.spriteOffset === null
    },
    style: ([_vm.baseThumbsStyling, _vm.activeThumbsStyling])
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27ba35dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/record/Thumbnail.vue
// module id = 1028
// module chunks = 1